@if (isLink) {
  <a href="#" (click)="navigateTo($event)" class="link">
    {{ value }}
    <span class="pi pi-chevron-right"></span>
  </a>
} @else {
  <div class="no-value">{{ noValue }}</div>
}
